export { default as graphqlClient } from './clientConfiguration';
export * from './clientGenerator';
export * from './client.types';
//# sourceMappingURL=index.js.map